import {
  assignRole as publicAssignRole,
  unassignRole as publicUnassignRole,
} from './social-groups-v2-group-role-roles.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onGroupRoleAssigned as publicOnGroupRoleAssigned } from './social-groups-v2-group-role-roles.public.js';
import { onGroupRoleUnassigned as publicOnGroupRoleUnassigned } from './social-groups-v2-group-role-roles.public.js';

export const assignRole: MaybeContext<
  BuildRESTFunction<typeof publicAssignRole> & typeof publicAssignRole
> = /*#__PURE__*/ createRESTModule(publicAssignRole);
export const unassignRole: MaybeContext<
  BuildRESTFunction<typeof publicUnassignRole> & typeof publicUnassignRole
> = /*#__PURE__*/ createRESTModule(publicUnassignRole);
/**
 * Triggered when a role is assigned to an existing group member.
 */
export const onGroupRoleAssigned: BuildEventDefinition<
  typeof publicOnGroupRoleAssigned
> &
  typeof publicOnGroupRoleAssigned = createEventModule(
  publicOnGroupRoleAssigned
);
/**
 * Triggered when a role is unassigned from a group member.
 */
export const onGroupRoleUnassigned: BuildEventDefinition<
  typeof publicOnGroupRoleUnassigned
> &
  typeof publicOnGroupRoleUnassigned = createEventModule(
  publicOnGroupRoleUnassigned
);

export {
  Role,
  WebhookIdentityType,
} from './social-groups-v2-group-role-roles.universal.js';
export {
  GroupRole,
  AssignRoleRequest,
  AssignRoleResponse,
  RoleAssignedToGroupMember,
  GroupMember,
  UnassignRoleRequest,
  UnassignRoleResponse,
  RoleUnassignedFromGroupMember,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  GroupRoleAssignedEnvelope,
  GroupRoleUnassignedEnvelope,
} from './social-groups-v2-group-role-roles.universal.js';
export {
  RoleWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './social-groups-v2-group-role-roles.universal.js';
